var SaveSuccess = /** @class */ (function () {
    function SaveSuccess(obj) {
        this.message = obj && obj.message || "";
        this.errorMessage = obj && obj.errorMessage || "";
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
    }
    return SaveSuccess;
}());
export { SaveSuccess };
